import { FC } from 'react';
import cn from 'bem-cn';

import peaceMobile from '../../../images/peace_balloon_mobile.png';
import peaceDesktop from '../../../images/peace_balloon_desktop.png';
import trophyMobile from '../../../images/trophy_balloon_mobile.png';
import trophyDesktop from '../../../images/trophy_balloon_desktop.png';
import heartMobile from '../../../images/heart_balloon_mobile.png';
import heartDesktop from '../../../images/heart_balloon_desktop.png';

import { CONDITIONS_URL } from '../../../constants';

import { ScreenSize, useGetScreenSize } from '../../../hooks';
import { Icon, ImageWithFadeIn, Modal, Stack } from '../../UI';

import { ProfilePublicityModalProps } from './ProfilePublicityModal.types';
import './ProfilePublicityModal.scss';

const b = cn('profile-publicity-modal');

export const ProfilePublicityModal: FC<ProfilePublicityModalProps> = ({ isOpen, onClose }) => {
    const screenSize = useGetScreenSize();
    const isTouch = screenSize < ScreenSize.Tablet;

    return (
        <Modal isOpen={isOpen} onClose={onClose} showDefaultCloseButton={false}>
            <Stack className={b()}>
                <h2 className={b('title')}>С публичным профилем вы сможете:</h2>

                <div className={b('content')}>
                    <div className={b('card')}>
                        <h3>Делиться своим профилем</h3>
                        <p>Вы и другие пользователи смогут делиться ссылкой на ваш профиль.</p>
                        <ImageWithFadeIn src={isTouch ? peaceMobile : peaceDesktop} alt="" />
                    </div>

                    <div className={b('card')}>
                        <h3>Участвовать в Рейтинге</h3>
                        <p>На основании вашего ИИндекса ваш профиль будет отражаться в общем Рейтинге.</p>
                        <ImageWithFadeIn src={isTouch ? trophyMobile : trophyDesktop} alt="" />
                    </div>

                    <div className={b('card')}>
                        <h3>Повышать узнаваемость</h3>
                        <p>Другие пользователи смогут попадать на ваш профиль из карточек ваших промптов.</p>
                        <ImageWithFadeIn src={isTouch ? heartMobile : heartDesktop} alt="" />
                    </div>
                </div>
                <p className={b('rules-warning')}>
                    Делая свой профиль публичным, я подтверждаю, что озанакомлен с&nbsp;пунктом&nbsp;2.7{' '}
                    <a href={CONDITIONS_URL} target="_blank" rel="noopener noreferrer">
                        Условий использования сервиса
                    </a>
                </p>
                <button className={b('close-button')} onClick={onClose} type="button" aria-label="Закрыть">
                    <Icon name="close" size={24} />
                </button>
            </Stack>
        </Modal>
    );
};
